import styles from "./SupportChat.module.scss";
import { Icon, IconType } from "../../../common/icons/Icon";
import { useSupportChatInput } from "./hooks/useSupportChatInput";

interface ISupportChatInputProps {
  chatId: string;
  onSend: (content: string, attachmentIds: number[]) => void;
  isSending: boolean;
  disabled?: boolean;
}

export const SupportChatInput = ({ chatId: _chatId, onSend, isSending, disabled }: ISupportChatInputProps) => {
  const {
    content,
    setContent,
    attachments,
    isUploading,
    fileInputRef,
    textareaRef,
    handleSend,
    handleKeyDown,
    handleFileChange,
    removeAttachment,
  } = useSupportChatInput({ onSend });

  return (
    <div className={styles.input_area}>
      {attachments.length > 0 && (
        <div className={styles.input_attachments}>
          {attachments.map((att) => (
            <div key={att.id} className={styles.input_attachment_chip}>
              <Icon type={IconType.DocumentCheck} width="13px" height="13px" />
              <span>{att.fileName}</span>
              <button className={styles.input_attachment_remove} onClick={() => removeAttachment(att.id)} type="button">
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <div className={styles.input_row}>
        <textarea
          ref={textareaRef}
          className={styles.input_textarea}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Напишете съобщение..."
          rows={3}
          disabled={disabled}
        />

        <div className={styles.input_side_actions}>
          <button
            className={styles.input_attach_btn}
            onClick={() => fileInputRef.current?.click()}
            disabled={isUploading || disabled}
            type="button"
            title="Прикачи файл"
          >
            {isUploading ? (
              <div className={styles.input_spinner} />
            ) : (
              <Icon type={IconType.Paperclip} width="16px" height="16px" />
            )}
          </button>

          <button
            className={styles.input_send_btn}
            onClick={handleSend}
            disabled={isSending || disabled || (!content.trim() && attachments.length === 0)}
            type="button"
            title="Изпрати"
          >
            <Icon type={IconType.SendIcon} width="18px" height="18px" />
          </button>
        </div>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
        accept="image/*,.heic,.heif,.pdf,.doc,.docx,.xlsx,.xls,.txt"
      />
    </div>
  );
};
